import * as React from "react";
import { WidgetWrapper } from "uxp/components";
import { IUIPropertyDefinitionMap, IWidgetTemplateProps, registerCardTemplate } from "../../../common/common";
import ActionRenderComponent from "../../../common/components/ActionRenderComponent";
import { SelectableItem, selectUIProps } from "../../../common/SelectableItem";
import { ContainerProperty, extractContainerProperties } from "../../../common/ui-props/ContainerProperty";
import { extractTextProperties, TextProperty } from "../../../common/ui-props/TextProperty";
import { extractContextData, loadInitialData, replaceWithData } from "../../../../util";
import { IContextData, useInitialContextData } from "../../../../hooks/useContextData";

const XPRProps: IUIPropertyDefinitionMap = {
    'container': ContainerProperty({
        background: {
            image: {
                image: '',
                position: 'center',
                size: 'cover'
            }
        },
        onClick: { type: 'open-url' }
    }),
    'topLabelContainer': ContainerProperty({
        background: {
            color: '',
            image: {
                image: "",
                position: "",
                size: "",
            },
        }
    }),
    'topLabel': TextProperty({
        text: '',
        color: '',
        size: '12px'
    }),
    'titlesContainer': ContainerProperty({
        background: { color: "" }
    }),
    'title': TextProperty({
        text: '',
        color: '',
        size: '12px',
        align: 'left'
    }),
    'subTitle': TextProperty({
        text: '',
        color: '',
        size: '12px',
        align: 'left'
    })
}

const XPR: React.FunctionComponent<IWidgetTemplateProps> = props => {

    let uiProps = props?.uiProps || {};

    const [actionData, setActionData] = React.useState({ action: null, contextData: {} })
    
    const [contextData, setContextData] = React.useState<IContextData>({})
    const [loading, setLoading] = React.useState(false)
    
    const { isLoading, initialContextData } = useInitialContextData(props)

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    // main container 
    let { styles } = extractContainerProperties(uiProps.container)
    if (!styles.backgroundImage) styles.backgroundImage = 'url("https://unsplash.it/600")'

    // toplabel container 
    let { styles: topLableContainerStyles } = extractContainerProperties(uiProps.topLabelContainer)
    // top lable 
    let { text: topLabel, styles: topLabelStyles } = extractTextProperties(uiProps.topLabel, 'Top Label')
    topLabel = replaceWithData(topLabel, contextData)

    // titles container
    let { styles: titlesContainerStyles } = extractContainerProperties(uiProps.titlesContainer)
    // titles
    let { text: title, styles: titleStyles } = extractTextProperties(uiProps.title, 'Bottom first line')
    title = replaceWithData(title, contextData)
    let { text: subTitle, styles: subTitleStyles } = extractTextProperties(uiProps.subTitle, 'bottom second line')
    subTitle = replaceWithData(subTitle, contextData)

    return <WidgetWrapper className="uxp-image-card-template">
        <SelectableItem
            designer={props.designer}
            props={selectUIProps(uiProps, XPRProps, 'container')}
            contextData={contextData}
        >
            <div className="image" style={styles} onClick={() => { setActionData({ action: uiProps?.container?.onClick || null, contextData: contextData }) }}>

                <div className="top-label-container" >
                    <SelectableItem
                        designer={props.designer}
                        props={selectUIProps(uiProps, XPRProps, 'topLabelContainer')}
                        contextData={contextData}
                    >
                        <div className="top-label" style={topLableContainerStyles} >
                            <SelectableItem
                                designer={props.designer}
                                props={selectUIProps(uiProps, XPRProps, 'topLabel')}
                                contextData={contextData}
                            >
                                <div className="top-label-text" style={topLabelStyles}>{topLabel}</div>
                            </SelectableItem>
                        </div>
                    </SelectableItem>
                </div>


                <div className="titles-container">
                    <SelectableItem
                        designer={props.designer}
                        props={selectUIProps(uiProps, XPRProps, 'titlesContainer')}
                        contextData={contextData}
                    >
                        <div className="titles" style={titlesContainerStyles}>
                            <div className="title">

                                <SelectableItem
                                    designer={props.designer}
                                    props={selectUIProps(uiProps, XPRProps, 'title')}
                                    contextData={contextData}
                                >
                                    <div className="text" style={titleStyles}>{title}</div>
                                </SelectableItem>
                            </div>
                            <div className="sub-title">

                                <SelectableItem
                                    designer={props.designer}
                                    props={selectUIProps(uiProps, XPRProps, 'subTitle')}
                                    contextData={contextData}
                                >
                                    <div className="text" style={subTitleStyles}>{subTitle}</div>
                                </SelectableItem>
                            </div>
                        </div>
                    </SelectableItem>
                </div>


            </div>
        </SelectableItem>

        <ActionRenderComponent
            designer={props.designer}
            uxpContext={props.uxpContext}
            {...actionData}
            onClose={() => setActionData({ action: null, contextData: {} })}
            onReloadWidget={() => { }}
        />

    </WidgetWrapper>
}


registerCardTemplate({
    id: 'image-card',
    name: "Image Card",
    description: 'Display an image with a main label and sublabel. Useful for showing a visual indicator and some statistic or KPI.',
    template: XPR,
    icon: ['fas', 'image'],
    complexity: 'easy'
});